import { render, staticRenderFns } from "./ObiDropdownToggle.vue?vue&type=template&id=6814b067&scoped=true&"
import script from "./ObiDropdownToggle.vue?vue&type=script&lang=js&"
export * from "./ObiDropdownToggle.vue?vue&type=script&lang=js&"
import style0 from "./ObiDropdownToggle.vue?vue&type=style&index=0&id=6814b067&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6814b067",
  null
  
)

export default component.exports